<template>
    <v-card tile>
        <v-card-text v-html="message"/>
    </v-card>
</template>

<script>
  import {VCard, VCardText} from 'vuetify/lib'

  export default {
    components: {
      VCard,
      VCardText
    },
    props: {
      message: {
        type: String,
        required: true
      }
    }
  };
</script>
